/**
 * Параметры сетей для `wallet_addEthereumChain`.
 *
 * Раньше в обоих местах (DepositLayout и claimOnChain) было захардкожено
 * «Hardhat Local» с локальным RPC — после переезда на мейннет кошелёк
 * попытался бы добавить Arbitrum под именем Hardhat и с нерабочим адресом.
 */
const KNOWN_CHAINS = {
    42161: {
        chainName: 'Arbitrum One',
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        blockExplorerUrls: ['https://arbiscan.io'],
    },
    31337: {
        chainName: 'Hardhat Local',
        rpcUrls: [], // подставит вызывающий: локальный RPC-прокси
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    },
};

/**
 * Собирает параметры сети для кошелька.
 * @param {number} chainId
 * @param {string} [fallbackRpc] — RPC, если для сети он не зашит (dev-прокси)
 * @returns {object|null} null, если сеть неизвестна — тогда добавлять её не пытаемся
 */
export function getAddChainParams(chainId, fallbackRpc) {
    const known = KNOWN_CHAINS[chainId];
    if (!known) return null;

    const rpcUrls = known.rpcUrls.length ? known.rpcUrls : (fallbackRpc ? [fallbackRpc] : []);
    if (!rpcUrls.length) return null;

    return {
        chainId: '0x' + Number(chainId).toString(16),
        chainName: known.chainName,
        rpcUrls,
        nativeCurrency: known.nativeCurrency,
        ...(known.blockExplorerUrls ? { blockExplorerUrls: known.blockExplorerUrls } : {}),
    };
}
